/* eslint-disable no-new */
import BraunSkuSliderController from '@/braun/Controllers/BraunSkuSliderController';
import { checkWishlistIcon } from '@/braun/Controllers/BraunWishlistController';
import initPdpRelatedProductsController from '@/utils/Controllers/PdpRelatedProductsController';

const jsEventsCallback = () => {
  BraunSkuSliderController();
  checkWishlistIcon();
};

export default () => {
  initPdpRelatedProductsController(jsEventsCallback);
};
